<style lang="less" scoped>
.content {
  margin: 30px 50px;
  position: relative;

  .loading {
    position: absolute;
    left: 45%;
    top: 150px;
  }

  .member {
    margin-top: 20px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-row-gap: 5px;
    background-color: @white;

    /deep/ .ant-btn {
      width: 60px;
      height: 24px;
      line-height: 24px;
      border: 1px solid @primary-color;
      background: #fff;
      color: @primary-color;
      float: right;
    }

    // .member-item{
    //   margin:0 5px;
    //   img{
    //     width:40px;
    //     height:40px;
    //     border:2px solid #CCC;
    //     border-radius:50%;
    //     margin:5px 10px;
    //   }
    //   .owner{
    //     color: blue !important;
    //     font-weight: bold;
    //   }
    //   .teacher::before{
    //     content: '🌷';
    //     color: @primary-color;
    //     font-size:1.2em;
    //   }
    //   .inClass{
    //     border:2px solid green;
    //   }
    // }
    .owner {
      color: blue !important;
      font-weight: bold;
      // .active{
      //   display: none;
      //   color:#ccc;
      // }
      // .active1{
      //   display: none;
      //   color: red;
      // }
      .del {
        display: none;
      }
    }

    .teacher::before {
      content: '🌷';
      color: @primary-color;
      font-size: 1.2em;
    }

    .inClass {
      border: 2px solid green;
    }

    .del {
      margin-right: 20px;
      float: right;
      color: #db5647;
      cursor: pointer;
    }

    .active {
      margin-right: 15px;
      float: right;
      color: #ccc;
      cursor: pointer;
      margin-top: 4px;
    }

    .active1 {
      margin-right: 15px;
      float: right;
      color: red;
      cursor: pointer;
      float: right;
      margin-top: 4px;
    }
  }

  .className {
    width: 220px;
    height: 44px;
    font-size: 20px;
    box-sizing: border-box;
    line-height: 44px;
    text-align: center;
    color: @primary-color;
    border: 1px solid @primary-color;
    border-radius: 12px;
    margin: auto;
    cursor: pointer;
  }

  .mess {
    width: 25px;
    height: 25px;
    float: right;
    cursor: pointer;
  }

  /deep/ .ant-list {
    width: 680px;
  }

  /deep/ .ant-list-item {
    padding: 15px 0px 10px 0px
  }

  /deep/ .ant-pagination {
    text-align: center;
  }

  /deep/ .ant-list-vertical .ant-list-item-meta {
    margin-bottom: 0px;
  }

  /deep/ .ant-list-item-meta-avatar {
    margin-right: 16px;
    margin-top: -6px;
  }

  /deep/ .ant-list-split .ant-list-item {
    border-bottom: none;
  }

  /deep/ .ant-list-something-after-last-item .ant-spin-container > .ant-list-items > .ant-list-item:last-child {
    border-bottom: none;
  }
}
</style>
<template>
  <div>
    <div class="content">
      <a-spin class="loading" v-show="loading"/>
      <!-- <div>头像绿色：在班级；头像灰色：不在班级；名称带🌷老师；名称蓝色加粗：群管理员</div> -->
      <div class="member">
        <a-list itemLayout="vertical" :pagination="pagination" :data-source="members">
          <a-list-item slot="renderItem" slot-scope="item">
            <a-list-item-meta>
              <div slot="title" :class="{owner:item.owner,teacher:item.isTea}">
                <!-- <img group="user-img" v-if="item.photo&&item.photo!=null" :src="item.photo" alt="">
                <img group="user-img" v-else src="/imgs/teacher.png" alt="" /> -->
                <span>{{ item.userName || item.member || item.owner }}</span>
                <img class="mess" @click="messForbden(item)" :src="item.isForbidden==0?speak:noSpeak" alt=""/>
              </div>
              {{ item }}
              <a-avatar slot="avatar" :src="item.photo"/>
            </a-list-item-meta>
          </a-list-item>
        </a-list>
      </div>
    </div>
  </div>
</template>

<script>
import WebIM from 'utils/WebIM'
import shareState from 'utils/shareState.js'
import speak from '@/assets/image/41-1.png'
import noSpeak from '@/assets/image/41-2.png'

export default {
  name: 'MemberClass',
  data() {
    return {
      speak,
      noSpeak,
      shareData: shareState.state,
      resBasePath: this.$userINfoBasePath + '/',
      admin: '',
      members: [], // 班级成员+IM群组成员
      teachers: [], // 班级教师
      groupOwner: [], // 群管理员
      classAllMember: [], //班级所有的学生
      groups: [], // 获取所有的群组
      loading: false,
      pagination: {
        onChange: page => {
          // console.log(page);
        },
        pageSize: 10,
      },
      studentId: '',// 邀请某个学生的ID
      groupId: ''
    }
  },
  watch: {
    $route() {
      // this.getMembers()
      // this.getClassMembers(this.$route.params.groupid)
      this.getV2MyClassStu()
    }
  },
  beforeMount() {
    // this.getClassMembers(this.$route.params.groupid)
    this.getV2MyClassStu()
  },
  methods: {
    getMembers() {
      // 将IM群组成员与班级成员信息进行合并。
      this.loading = true
      const groupid = this.$route.params.groupid
      //const classMembers = this.getClassMembers(groupid)
      const vm = this
      const options = {
        groupId: groupid, // 群组id
        success: function (res) {
          // console.log(res)
          vm.admin = res.data[0].owner
          vm.members = res.data[0].affiliations.reverse()
          // vm.members = res.data[0].affiliations.reduce((pre, cur) => {
          //   const target = pre.find(ee => ee.id === cur.member)
          //   if (target) {
          //     Object.assign(target, cur)
          //   } else {
          //     pre.push(Object.assign(cur, { inClass: false, photo: 'imgs/logo.png' }))
          //   }
          //   return pre
          // }, classMembers)
          vm.loading = false
          //console.log(vm.members)
        },
        error: function (e) {
          vm.$message.error('获取群组成员失败！')
        }
      }
      WebIM.conn.getGroupInfo(options)

    },
    getClassMembers(groupid) {
      // 根据IM群组ID匹配班级并获取班级成员（包括老师）
      this.$fetch({
        url: this.$baseUrl + 'ebook/class/common/getMyClass'
      }).loading(
          () => (this.loading = true),
          () => (this.loading = false)
      ).done(res => {
        const myClass = res.resultData.filter(c => c.groupTag === groupid)
        if (myClass.length > 0 && myClass[0].students.length > 0) {
          const classMembers = myClass[0].students.map(s => {
            const photo = s.photo && s.photo != null ? this.$userINfoBasePath + '/' + s.photo : 'imgs/stu-photo.png'
            return Object.assign(s, {photo, inClass: true})
          })
          classMembers.unshift(this.getTeacher(myClass[0])) // 在数组前追加老师
          this.members = classMembers
        } else {
          this.members = []
        }
      })
    },
    getTeacher(myClass) {
      if (myClass) {
        return {
          id: myClass.teaId,
          userName: myClass.teaName,
          isTea: true,
          photo: this.$store.state.userInfo.photo ? this.$userINfoBasePath + '/' + this.$store.state.userInfo.photo : 'imgs/teacher.png',
          inClass: true
        }
      }
      return null
    },
    getClassInfo() { //获取群组信息
      let _this = this
      _this.$fetch({
        url: _this.$baseUrl + 'ebook/class/common/getClassInfoById',
        body: {id: sessionStorage.getItem('classId')}
      }).loading(
          () => (this.loading = true),
          () => (this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          _this.groups = res.resultData.groups
          _this.classAllMember = res.resultData.students
        }
      })
    },
    messForbden(item) {
      // 班级禁言
      // console.log(item)
      this.groupId = this.$route.params.groupid
      // 获取群组ID
      // console.log(this.groupId)
      // console.log(localStorage.getItem('classID'))
      const param = {
        groupTag: this.groupId,
        studentId: item.id,
        forbiddenType: '1',
        id: localStorage.getItem('classID'),
        userId: item.id
      }
      let _this = this
      const url = item.isForbidden === 0 ? 'ebook/group/common/setForbiddenWords' : 'ebook/group/common/cancelForbiddenWords'
      _this.$fetch({
        url: _this.$baseUrl + url,
        body: param
      }).loading(
          () => {
            _this.loading = true
          },
          () => {
            _this.loading = false
          }
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          _this.getClassMembers(_this.$route.params.groupid)
        }
      })
    },

    invitOk() {
      // 邀请学生确定
      const param = {
        groupId: this.groupId,
        studentId: this.studentId
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/class/common/inviteStudentJoinGroup',
        body: param
      }).loading(
          () => (this.loading = true),
          () => (this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.getClassMembers(this.$route.params.groupid)
        }
      })
    },
    getV2MyClassStu() {
      // 根据班级id 获取班级学生列表--重新拆分接口，减少原大接口耗时
      const _this = this
      _this.$fetch({
        url: _this.$baseUrl + 'ebook/class/common/v2/getV2MyClassStu',
        body: {classId: localStorage.getItem('classID')}
      })
          .done((res) => {
            if (res && res.success && res.resultCode === 0) {
              if (res.resultData.length > 0) {
                const classMembers = res.resultData.map(s => {
                  if (s.isTea === 0) {
                    const photo = s.photo && s.photo != null ? this.$userINfoBasePath + '/' + s.photo : 'imgs/stu-photo.png'
                    return Object.assign(s, {photo})
                  } else {
                    const photo = s.photo && s.photo != null ? this.$userINfoBasePath + '/' + s.photo : 'imgs/teacher.png'
                    return Object.assign(s, {photo})
                  }
                })
                _this.members = classMembers
                console.log('getV2MyClassStu')
                console.log(res)
                console.log(classMembers)
              }
            }
          })
    }
  }
}
</script>
